module.exports = __webpack_public_path__ + "img/novapay-logo.3d296787.jpg";